import PropTypes from "prop-types";

const Badge = ({ children, variant = "default", className = "" }) => {
  const variants = {
    default: {
      color: "#515164",
      backgroundColor: "#F2F4F7",
    },
    success: {
      color: "#01793B",
      backgroundColor: "#E8F5E9",
    },
    error: {
      color: "#DC2626",
      backgroundColor: "#FEE2E2",
    },
    warning: {
      color: "#B45309",
      backgroundColor: "#FEF3C7",
    },
  };

  const style = variants[variant] || variants.default;

  return (
    <span
      className={`text-xs sm:text-sm font-semibold px-2.5 sm:px-3 py-1 sm:py-1.5 rounded-full ${className}`}
      style={style}
    >
      {children}
    </span>
  );
};

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(["default", "success", "error", "warning"]),
  className: PropTypes.string,
};

export default Badge;
